import { FC, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import axios from 'axios'
import { Alert, Box, Paper, Stack, Typography } from '@mui/material'
import Logo from 'views/components/UI/Logo'

interface Certificate {
  name: string
  company_name: string
  process_name: string
  space_name: string
  starts_at: string
  dates?: Array<{ kind: string; starts_at: string }>
  hours: number
  certificate_sent_at: string
}

const TrainingCertificateValidation: FC = () => {
  const { id } = useParams<{ id: string }>()
  const [certificate, setCertificate] = useState<Certificate | null>(null)
  const [error, setError] = useState('')
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_MAIN_API}/trainings/certificates/${id}`)
      .then((response) => setCertificate(response.data.data as Certificate))
      .catch(() => setError('No se encontró un certificado vigente con este identificador.'))
  }, [id])
  return <Box sx={{ minHeight: '100vh', background: '#F7FAFD', p: { xs: 2, sm: 5 } }}>
    <Paper sx={{ maxWidth: 700, mx: 'auto', p: { xs: 2.5, sm: 4 }, borderRadius: 3 }}>
      <Box sx={{ width: 170, mb: 3 }}><Logo width="100%" /></Box>
      <Typography variant="h5" sx={{ color: '#163247', fontWeight: 700, mb: 2 }}>Validación de certificado</Typography>
      {error && <Alert severity="error">{error}</Alert>}
      {certificate && <Stack spacing={1.5}><Alert severity="success">Certificado de entrenamiento Bluesite válido.</Alert>
        <Typography><strong>Participante:</strong> {certificate.name}</Typography>
        <Typography><strong>{certificate.dates ? 'Entrenamiento' : 'Espacio'}:</strong> {certificate.space_name}</Typography>
        <Typography><strong>Convocatoria:</strong> {certificate.process_name}</Typography>
        <Typography><strong>Empresa:</strong> {certificate.company_name}</Typography>
        <Typography><strong>Intensidad:</strong> {certificate.hours} horas</Typography>
        {certificate.dates ? certificate.dates.map((item) => <Typography key={item.kind}><strong>{({ betesa: 'Betesa', skills_3d: '3D Skills', ideal_profiles: 'Perfiles ideales' } as Record<string, string>)[item.kind]}:</strong> {new Date(item.starts_at).toLocaleDateString('es-CO', { timeZone: 'America/Bogota' })}</Typography>)
          : <Typography><strong>Fecha:</strong> {new Date(certificate.starts_at).toLocaleDateString('es-CO', { timeZone: 'America/Bogota' })}</Typography>}
      </Stack>}
    </Paper>
  </Box>
}

export default TrainingCertificateValidation
